module.exports = __webpack_public_path__ + "img/電気回路_3_5_1.a987f724.png";